// extracted by mini-css-extract-plugin
module.exports = {"root":"LightningPayToggle_root__3egsT","icon":"LightningPayToggle_icon__1LF4m","text":"LightningPayToggle_text__wySpg","toggle":"LightningPayToggle_toggle__2Ynft"};